import React from 'react';

import { Title } from '../../../components/Title';
import { useOfferContext } from '../../../context';
import { getOfferSubtitle } from '../../../utils/computedProps/title/getOfferSubtitle';

export function TitleContainer() {
  const { title, subtitle: offerSubtitle, isTop, isNewbuilding, offer } = useOfferContext();
  const subtitle = getOfferSubtitle({
    isNewbuilding,
    originalSubtitle: offerSubtitle,
    house: offer.newbuilding?.house,
  });

  return <Title isTop={isTop} title={title} subtitle={subtitle} />;
}
